import StyledInput from 'library/components/form/input';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import {
  Container,
  FieldContainer, AddUrlBtn,
} from './styles';
import { Icon } from '../styles';

// loader, validation, fix remove
const Urls = ({
  name,
  data,
  fields,
  update,
  append,
  isLoading,
  onUpload,
}) => {
  const {
    formState: { errors }, getValues,
  } = useFormContext();
  const values = getValues(name) || [];

  useEffect(() => {
    if(!isLoading && !values.every(({ storageId }) => storageId) && data?.id) {
      update(fields.length - 1, { value: values[fields.length - 1].value, storageId: data?.id });
      append({ value: '', storageId: null });
    }
  }, [data?.id, isLoading, values]);

  return (
    <Container>
      {
        fields.map(
          (
            field,
            index,
          ) => {
            const handleUpload = () => {
              onUpload({ url: getValues(`${name}[${index}].value`) });
            };

            return (
              <FieldContainer key={field.id} isReadOnly={getValues(`${name}[${index}].storageId`)} isLoading={isLoading && !getValues(`${name}[${index}].storageId`)}>
                <StyledInput
                  placeholder="Paste URL here..."
                  iconClassName={!getValues(`${name}[${index}].storageId`) ? 'icon-pencil' : 'icon-check'}
                  name={`${name}[${index}].value`}
                  isLoading={isLoading && !getValues(`${name}[${index}].storageId`)}
                  readOnly={!!getValues(`${name}[${index}].storageId`)}
                  type="url"
                />
                <AddUrlBtn
                  type="button"
                  onClick={handleUpload}
                  disabled={(isLoading && !getValues(`${name}[${index}].storageId`)) || errors[name] || getValues(`${name}[${index}].storageId`)}
                >
                  <Icon size={30} className="icon-cloud-upload" />

                </AddUrlBtn>
              </FieldContainer>
            );
          },
        )
      }
    </Container>
  );
};

export default Urls;
// {/*{...register(`${name}[${index}].value`, { shouldUnregister: false, value: fieldValue })}*/}
